import MyModal from "./MyModal";
import Collection from "../../Model/Collection";
import Loc from "../../../Loc/Loc";

interface RecepModalProps {
    isCollection: boolean;
    item: any;
    collection?: Collection;
}

export default function RecepModal(props: RecepModalProps) {
    const marginRecepButton: string = props.isCollection ? "" : "14px";

    return (
        <MyModal
            className={"btn btn-fives btn-sm"}
            style={{ padding: "4px", marginLeft: marginRecepButton }}
            textButton={Loc.trad().RecepModalReceive}
            disabled={false}
            element={"recepModal"}
            isCollection={props.isCollection}
            item={props.item}
            collection={props.collection}
        ></MyModal>
    );
}